import React, { useEffect } from "react";
import { useSessionContext } from './Session';
import { useLocation } from "./Router";
import { pageLoad } from "./Analytics";


const PageLoadComponent = (props) => {
  const { analyticsOptions = {} } = props;
  const { sessionContext } = useSessionContext();
  const { pathname, hash } = useLocation();

  useEffect(() => {
    pageLoad({
      path: pathname,
      hash,
      sessionContext,
      options: analyticsOptions,
    });
  }, [pathname, hash, sessionContext, analyticsOptions]);

  return (
    <>
    </>
  );
};

export default PageLoadComponent;
